import { createContext } from 'react'

const pageContext = createContext()
pageContext.displayName = 'InertiaPageContext'

export default pageContext
